module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_5010.059bf081.png";